import {loginRoutes} from './login.routes';

import {PasswordCredentialsService} from './password-credential.service';
import {InstallationService} from './installation.service';
import {LoginService} from './login.service';
import {ContactPointService} from './contact-point-service';
import {UuidService} from './uuidService';
import {DeviceTokenService} from './DeviceTokenService';
import {RedirectDirective} from './RedirectDirective';
import {AccountCreationHelpService} from './account/AccountCreationHelpService';
import {RedirectService} from './RedirectService';

import {FlowStateService} from '../landing/FlowStateService';
import {FlowService} from '../landing/flow.service';
import {loginEmailModule} from './email/LoginEmailModule';
import {loginUsernameModule} from './username/LoginUsernameModule';
import {loginVerificationModule} from './verification/loginVerificationModule';

export var loginModule = angular.module('authentication.login', [
        'pascalprecht.translate',
        'ui.router',
        loginEmailModule.name,
        loginUsernameModule.name,
        loginVerificationModule.name
    ])
        .config(loginRoutes)
        .service('passwordCredentialsService', PasswordCredentialsService)
        .service('installationService', InstallationService)
        .service('loginService', LoginService)
        .service('contactPointService', ContactPointService)
        .service('uuidService', UuidService)
        .service('deviceTokenService', DeviceTokenService)
        .directive('redirect', RedirectDirective)
        .service('accountCreationHelpService', AccountCreationHelpService)
        .service('flowStateService', FlowStateService)
        .service('flowService', FlowService)
        .service('redirectService', RedirectService)
    ;

